import common from './common';
import Module from './module';
import Util from './lib/util';

class Contact extends Module {

    init() {
        return super.init().then(() => this.emit('init'));
    }

    main() { }

    bindEvents() {
        // school finder filters
		$('.nha-school-finder-filter-state select').on('change', Util.debounce(e => this.redirectToSchoolFinder({ state: e.currentTarget.value })));
        $('.nha-school-finder-filter-zip input.nha-form-control, .nha-school-finder-bar .nha-school-finder-filter-zip input.nha-form-control').on('change', Util.debounce(e => this.redirectToSchoolFinder({ zipcode: e.currentTarget.value })));
        $('.nha-school-finder-filter-zip .nha-btn, .nha-school-finder-bar .nha-school-finder-filter-zip .nha-btn').on('click', Util.debounce(e => this.redirectToSchoolFinder({ zipcode: $('.nha-school-finder-filter-zip .nha-form-control').val() })));

        $('.nha-contact-form-wrapper').on('click.validate focusin.validate focusout.validate keyup.validate', e => this.onFormChanged(e));
        $('.nha-contact-form-wrapper').on('focusout.validate', Util.debounce(e => this.onFormBlurred(e)));
    }

    onFormBlurred(e) {
        $(e.target).valid();    // validate the field that was blurred
        this.onFormChanged(e);
    }

    onFormChanged(e) {
        $('.nha-form-control').each((e, el) => {
            let field = $(el);
            let group = field.closest('.nha-form-group');

            group.removeClass('nha-form-error');
            if (field.hasClass('input-validation-error') && !field.hasClass('valid')) {
                $('#contact-us-submit-btn').removeAttr('disabled');
                group.addClass('nha-form-error');
            }
        });

        let reasonForContacting = document.getElementsByName("Form.ReasonForContacting"); 
        let preferredCommunicationLanguage = document.getElementsByName("Form.PreferredCommunicationLanguage");
        if (reasonForContacting[0][1].selected == true) {
            $('.optionalFields').show();
            $('.questions').show();
            $('.messages').hide();
        } else {
            $('.optionalFields').hide();
            $('.questions').hide();
            $('.messages').show();
        }
        if (preferredCommunicationLanguage[0][12].selected == true) {
            $('.otherLanguageField').show();
        } else {
            $('.otherLanguageField').hide();
        }
    }

    redirectToSchoolFinder(e) {
		const url = `/${common.getCultureCode()}/school-finder?`;

		const state = Util.trim(e.state);
		const zipcode = Util.trim(e.zipcode);

		if (Util.hasValue(zipcode)) {
			window.location.href = `${url}zipcode=${zipcode}`;
		} else if (Util.hasValue(state)) {
			window.location.href = `${url}state=${state}`;
		}
	}
}

const contact = new Contact();

common.on('init', () => contact.init());

export default contact;



// WEBPACK FOOTER //
// ./wwwroot/js/app/contact.js